import { render, staticRenderFns } from "./MainNav.vue?vue&type=template&id=e844b67c&scoped=true&"
import script from "./MainNav.vue?vue&type=script&lang=ts&"
export * from "./MainNav.vue?vue&type=script&lang=ts&"
import style0 from "./MainNav.vue?vue&type=style&index=0&id=e844b67c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e844b67c",
  null
  
)

export default component.exports